import { useState } from "react";
import emailjs from "@emailjs/browser";
import { Helmet } from "react-helmet";
import { useT } from "../hooks/useLang";

const SERVICE_ID  = "service_12xz0wi";
const TEMPLATE_ID = "template_z0lrx4q";
const PUBLIC_KEY  = "oCBbqt2V5HbnAPlkF";

const titleStyle = {
  fontFamily: "var(--font-display)",
  color: "#E0392B",
  fontSize: "clamp(2rem, 5vw, 3rem)",
  WebkitTextStroke: "1.5px var(--ink)",
  textShadow: "3px 3px 0 var(--ink)",
  lineHeight: 1.05,
  marginBottom: "0.5rem",
};

const socials = [
  {
    href: "https://www.instagram.com/startingfivepoint/",
    label: "Instagram",
    note: "@startingfivepoint",
    color: "#C13584",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="white" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608.975-.975 2.242-1.246 3.608-1.308C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948 0-3.259-.014-3.668-.072-4.948-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    ),
  },
  {
    href: "https://www.tiktok.com/@starting.five8",
    label: "TikTok",
    note: "@startingfive8",
    color: "#010101",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="white" aria-hidden="true">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
      </svg>
    ),
  },
];

export default function Contact() {
  const t = useT();
  const [form, setForm] = useState({ nom: "", email: "", objet: "", message: "" });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const infos = [
    { icon: "📧", title: "Email",     sub: "fivepoint228@gmail.com", note: t("reponse24h"),  color: "var(--primary)" },
    { icon: "📞", title: "Téléphone", sub: "+228 90 47 87 25",        note: t("lunVen"),      color: "var(--green)" },
    { icon: "📍", title: "Adresse",   sub: "Cité Mokpokpo",           note: "Adidogomé Lomé, Togo", color: "var(--red)" },
  ];

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, { ...form }, PUBLIC_KEY);
      setStatus("success");
      setForm({ nom: "", email: "", objet: "", message: "" });
    } catch (err) {
      console.error("Erreur EmailJS :", err);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pb-16" style={{ background: "var(--bg)", paddingTop: "10px" }}>
      <Helmet>
        <title>Starting Five - Accueil</title>
        <meta name="description" content="Starting Five, groupe togolais proposant des services innovants pour simplifier votre quotidien." />
      </Helmet>

      {/* Zigzag juste sous la navbar */}
      <div className="zigzag-band" />

      <div className="max-w-4xl mx-auto px-6 pt-16">

        <span className="eyebrow">{t("onVousEcoute")}</span>
        <h1 style={titleStyle}>{t("nousContacter")}</h1>
        <p className="mb-10 font-medium" style={{ color: "var(--ink-soft)" }}>
          {t("uneQuestion")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Infos de contact */}
          <div className="space-y-4">
            {infos.map((info) => (
              <div key={info.title} className="brut-card p-5 flex items-start gap-4">
                <div style={{
                  width: 50, height: 50,
                  border: "3px solid var(--border)", borderRadius: 10,
                  background: info.color,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "1.4rem", flex: "none",
                  boxShadow: "var(--shadow-sm)",
                }}>
                  {info.icon}
                </div>
                <div>
                  <div className="font-bold text-base mb-0.5" style={{ color: "var(--ink)" }}>{info.title}</div>
                  <div className="font-medium" style={{ color: "var(--ink-soft)" }}>{info.sub}</div>
                  <div className="text-xs mt-1" style={{ color: "var(--ink-soft)" }}>{info.note}</div>
                </div>
              </div>
            ))}

            {/* Réseaux sociaux */}
            {socials.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                className="brut-card p-5 flex items-start gap-4 hover:-translate-x-0.5 hover:-translate-y-0.5 transition-transform"
                style={{ textDecoration: "none", display: "flex" }}>
                <div style={{
                  width: 50, height: 50,
                  border: "3px solid var(--border)", borderRadius: 10,
                  background: s.color,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flex: "none",
                  boxShadow: "var(--shadow-sm)",
                }}>
                  {s.icon}
                </div>
                <div>
                  <div className="font-bold text-base mb-0.5" style={{ color: "var(--ink)" }}>{s.label}</div>
                  <div className="font-medium" style={{ color: "var(--ink-soft)" }}>{s.note}</div>
                  <div className="text-xs mt-1" style={{ color: "var(--primary)", fontWeight: 700 }}>{t("voirNotrePage")}</div>
                </div>
              </a>
            ))}
          </div>

          {/* Formulaire */}
          <div className="brut-card p-6">
            <h2 className="font-bold text-xl mb-5"
              style={{ fontFamily: "var(--font-display)", color: "var(--primary)" }}>
              {t("envoyerUnMessage")}
            </h2>

            {status === "success" && (
              <div className="mb-4 p-3 rounded-lg text-sm font-bold"
                style={{ background: "#d1fae5", border: "2px solid #059669", color: "#065f46" }}>
                {t("successMsg")}
              </div>
            )}
            {status === "error" && (
              <div className="mb-4 p-3 rounded-lg text-sm font-bold"
                style={{ background: "#fee2e2", border: "2px solid #dc2626", color: "#991b1b" }}>
                {t("errorMsg")}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              {[
                { name: "nom",   label: t("nom"),   type: "text",  ph: "Votre nom" },
                { name: "email", label: t("email"), type: "email", ph: "votre@email.com" },
                { name: "objet", label: t("objet"), type: "text",  ph: "Sujet de votre message" },
              ].map((f) => (
                <div key={f.name}>
                  <label className="brut-label">{f.label} *</label>
                  <input type={f.type} name={f.name} value={form[f.name]}
                    onChange={handleChange} required placeholder={f.ph}
                    className="brut-input" />
                </div>
              ))}
              <div>
                <label className="brut-label">{t("message")} *</label>
                <textarea name="message" value={form.message} onChange={handleChange}
                  required rows={5} placeholder="Votre message..."
                  className="brut-input" style={{ resize: "vertical" }} />
              </div>
              <button type="submit" disabled={loading}
                className="brut-btn w-full justify-center disabled:opacity-50"
                style={{
                  background: "var(--accent)", color: "var(--ink)",
                  border: "3px solid var(--border)", boxShadow: "var(--shadow-sm)",
                }}>
                {loading ? t("envoi") : t("envoyer")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}